<kt-portlet>
  <kt-portlet-header [class]="'card-head-lg'">
    <ng-container ktPortletTitle>
      <span>Login History</span>
    </ng-container>
  </kt-portlet-header>

  <kt-portlet-body *ngIf="!loading">
    <div *ngIf="result">
      <kt-device-history [result]="result.history" [contact_id]="contactId"></kt-device-history>
    </div>
    <div *ngIf="!result" class="d-flex justify-content-center">
      <p>there is no data</p>
    </div>
  </kt-portlet-body>
</kt-portlet>
